import { render } from "./ClaudeAIBotSettings.vue?vue&type=template&id=17188e40"
import script from "./ClaudeAIBotSettings.vue?vue&type=script&lang=js"
export * from "./ClaudeAIBotSettings.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__